<template>
  <v-card ref="advanced">
    <v-toolbar fixed dark color="rgb(33, 66, 148)" style="border-radius:0px">
      <v-btn icon dark @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title dense style="color:#fff;">Advanced Settings</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn id="submit" dark text @click="save()">Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text style="width:100%;height:auto;max-height: auto;padding:0px">
      <v-expansion-panels width="100%" style="padding:0px;height:auto" accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="fs-12">
              VIP Access Number
              <br />
              <br />
              <span
                class="small"
                style="color:#c5c5c5;min-height:29px;display:block;"
              >List of users who can have unlimited Internet Access</span>
            </span>
            <span class="fs-10 pb-1"></span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              style="display: grid;grid-template-columns: repeat(3, auto);"
              v-for="(item, index) in advancedSettings.vipNumber"
              :key="'vipNumber' + index"
            >
              <v-text-field
                type="tel"
                :maxlength="10"
                dense
                v-model="item.number"
                placeholder="Mobile Number"
                class="mr-1 compact"
                :rules="[
                  () => !!item.number || 'This field is required',
                  () =>
                    (!!item.number && item.number.length == 10) ||
                    'Mobile must be 10 characters',
                ]"
                counter="10"
                requrired
                :key="`vip-number-${index}`"
                @input="validate()"
                @change="validate()"
                @blur="validate()"
              >
                <v-icon
                  slot="append"
                  color="red"
                  style="font-size:8px;padding-top: 5px;"
                >mdi-asterisk</v-icon>
              </v-text-field>
              <v-text-field
                dense
                v-model="item.name"
                placeholder="Name"
                class="ml-1 compact"
                :key="`vip-name-${index}`"
              ></v-text-field>
              <v-icon
                medium
                color="#f26547"
                @click="
                  advancedSettings.vipNumber.splice(index, 1);
                  validate();
                "
              >mdi-close-circle</v-icon>
            </div>
            <v-btn
              style="float:right;color:#fff;"
              @click="
                advancedSettings.vipNumber.push({ number: '', name: '' });
                validate();
              "
              small
              color="#48bb78"
            >Add</v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="fs-12">
              Block Number
              <br />
              <br />
              <span class="small" style="color:#c5c5c5;min-height:29px;display:block;">
                List of users who are blocked and cannot have Internet
                Access
              </span>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              style="display: grid;grid-template-columns: repeat(3, auto);"
              v-for="(item, index) in advancedSettings.blockNumber"
              :key="'blockNumber' + index"
            >
              <v-text-field
                :maxlength="10"
                dense
                v-model="item.number"
                placeholder="Mobile Number"
                type="tel"
                class="mr-1 compact"
                :rules="[
                  () => !!item.number || 'This field is required',
                  () =>
                    (!!item.number && item.number.length == 10) ||
                    'Mobile must be 10 characters',
                ]"
                counter="10"
                requrired
                :key="`block-number-${index}`"
                @input="validate()"
                @change="validate()"
                @blur="validate()"
              >
                <v-icon
                  slot="append"
                  color="red"
                  style="font-size:8px;padding-top: 5px;"
                >mdi-asterisk</v-icon>
              </v-text-field>
              <v-text-field
                dense
                v-model="item.name"
                placeholder="Name"
                class="ml-1 compact"
                :key="`vip-name-${index}`"
              ></v-text-field>
              <v-icon
                medium
                color="#f26547"
                @click="
                  advancedSettings.blockNumber.splice(index, 1);
                  validate();
                "
              >mdi-close-circle</v-icon>
            </div>
            <v-btn
              style="float:right;color:#fff;"
              @click="
                advancedSettings.blockNumber.push({ number: '', name: '' });
                validate();
              "
              small
              color="#48bb78"
            >Add</v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="fs-12">
              Whitelist Number
              <br />
              <br />
              <span
                class="small"
                style="color:#c5c5c5;min-height:29px;display:block;"
              >Only these phone numbers will get internet access</span>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              style="display: grid;grid-template-columns: repeat(3, auto);"
              v-for="(item, index) in advancedSettings.whitelistNumber"
              :key="'whiteListNumber' + index"
            >
              <v-text-field
                type="tel"
                :maxlength="10"
                dense
                v-model="item.number"
                placeholder="Mobile Number"
                class="mr-1 compact"
                :rules="[
                  () => !!item.number || 'This field is required',
                  () =>
                    (!!item.number && item.number.length == 10) ||
                    'Mobile must be 10 characters',
                ]"
                counter="10"
                requrired
                :key="`wl-number-${index}`"
                @input="validate()"
                @change="validate()"
                @blur="validate()"
              >
                <v-icon
                  slot="append"
                  color="red"
                  style="font-size:8px;padding-top: 5px;"
                >mdi-asterisk</v-icon>
              </v-text-field>
              <v-text-field
                dense
                v-model="item.name"
                placeholder="Name"
                class="ml-1 compact"
                :key="`wl-name-${index}`"
              ></v-text-field>
              <v-icon
                medium
                color="#f26547"
                @click="
                  advancedSettings.whitelistNumber.splice(index, 1);
                  validate();
                "
              >mdi-close-circle</v-icon>
            </div>
            <v-btn
              style="float:right;color:#fff;"
              @click="
                advancedSettings.whitelistNumber.push({ number: '', name: '' });
                validate();
              "
              small
              color="#48bb78"
            >Add</v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="fs-12">
              VIP Access MAC
              <br />
              <br />
              <span
                class="small"
                style="color:#c5c5c5;min-height:29px;display:block;"
              >These MAC ID will get unlimited internet access</span>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              style="display: grid;grid-template-columns: repeat(3, auto);"
              v-for="(item, index) in advancedSettings.whitelistMac"
              :key="'whitelistMac' + index"
            >
              <v-text-field
                type="text"
                :maxlength="17"
                dense
                v-model="item.mac"
                placeholder="Mac XX-XX-XX-XX-XX-XX"
                class="mr-1 compact"
                :rules="[
                  () => !!item.mac || 'This field is required',
                  () =>
                    (!!item.mac && item.mac.length == 17) ||
                    'Mac must be 10 characters',
                ]"
                counter="17"
                requrired
                :key="`wlm-mac-${index}`"
                @input="validate()"
                @change="validate()"
                @blur="validate()"
              >
                <v-icon
                  slot="append"
                  color="red"
                  style="font-size:8px;padding-top: 5px;"
                >mdi-asterisk</v-icon>
              </v-text-field>
              <v-text-field
                dense
                v-model="item.name"
                placeholder="Name"
                class="ml-1 compact"
                :key="`wlm-name-${index}`"
              ></v-text-field>
              <v-icon
                medium
                color="#f26547"
                @click="
                  advancedSettings.whitelistMac.splice(index, 1);
                  validate();
                "
              >mdi-close-circle</v-icon>
            </div>
            <v-btn
              style="float:right;color:#fff;"
              @click="
                advancedSettings.whitelistMac.push({ mac: '', name: '' });
                validate();
              "
              small
              color="#48bb78"
            >Add</v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="fs-12">
              Block MAC ID
              <br />
              <br />
              <span
                class="small"
                style="color:#c5c5c5;min-height:29px;display:block;"
              >These MAC ID will blocked from internet access</span>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              style="display: grid;grid-template-columns: repeat(3, auto);"
              v-for="(item, index) in advancedSettings.blacklistMac"
              :key="'blacklistMac' + index"
            >
              <v-text-field
                type="text"
                :maxlength="17"
                dense
                v-model="item.mac"
                placeholder="Mac XX-XX-XX-XX-XX-XX"
                class="mr-1 compact"
                :rules="[
                  () => !!item.mac || 'This field is required',
                  () =>
                    (!!item.mac && item.mac.length == 17) ||
                    'Mac must be 10 characters',
                ]"
                counter="17"
                requrired
                :key="`wlm-mac-${index}`"
                @input="validate()"
                @change="validate()"
                @blur="validate()"
              >
                <v-icon
                  slot="append"
                  color="red"
                  style="font-size:8px;padding-top: 5px;"
                >mdi-asterisk</v-icon>
              </v-text-field>
              <v-text-field
                dense
                v-model="item.name"
                placeholder="Name"
                class="ml-1 compact"
                :key="`blm-name-${index}`"
              ></v-text-field>
              <v-icon
                medium
                color="#f26547"
                @click="
                  advancedSettings.blacklistMac.splice(index, 1);
                  validate();
                "
              >mdi-close-circle</v-icon>
            </div>
            <v-btn
              style="float:right;color:#fff;"
              @click="
                advancedSettings.blacklistMac.push({ mac: '', name: '' });
                validate();
              "
              small
              color="#48bb78"
            >Add</v-btn>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
export default {
  props: ["showAdvancedSettings", "advancedSettings"],
  components: {},
  data: () => {
    return {
      error: null,
      formHasErrors: false,
      errorMessage: {
        blockNumber: "Error in Blocked Numbers. Cannot Save",
        vipNumber: "Error in VIP Numbers. Cannot Save",
        whitelistMac: "Error in Whitelist MAC IDs. Cannot Save",
        blacklistMac: "Error in Blacklist MAC IDs. Cannot Save",
        whitelistNumber: "Error in Whitelist Numbers. Cannot Save"
      }
    };
  },
  methods: {
    close: function() {
      this.$emit("close");
    },
    save: function() {
      this.validate();
      if (this.formHasErrors)
        this.$emit("error", this.errorMessage[this.error]);
      else this.$emit("save", this.advancedSettings);
    },
    validate: function() {
      var pair, x, y;
      for (var setting in this.advancedSettings) {
        if (
          setting != "settingId" &&
          setting != "whitelistMac" &&
          setting != "blacklistMac" &&
          setting != "vipMac"
        ) {
          for (x in this.advancedSettings[setting]) {
            console.log(
              this.advancedSettings[setting][x].number.substring(0, 10)
            );
            this.advancedSettings[setting][x].number = this.advancedSettings[
              setting
            ][x].number.substring(0, 10);
            pair = this.advancedSettings[setting][x];
            if (pair.number && pair.number.length == 10) {
              //console.log("pass", setting, pair.number);
            } else {
              if (
                this.advancedSettings[setting].length == 1 &&
                (pair.number == null || pair.number == "") &&
                (pair.name == null || pair.name == "")
              ) {
                //console.log("pass single blank row", setting, pair.number);
              } else {
                //console.log("invalid", setting, pair.number);
                this.error = setting;
                this.formHasErrors = true;
                return 0;
              }
            }
          }
        } else {
          if (setting == "whitelistMac" || setting == "blacklistMac") {
            for (y in this.advancedSettings[setting]) {
              console.log(
                this.advancedSettings[setting][y].mac.substring(0, 17)
              );
              this.advancedSettings[setting][y].mac = this.advancedSettings[
                setting
              ][y].mac.substring(0, 17);
              pair = this.advancedSettings[setting][y];
              if (pair.mac && pair.mac.length == 17) {
                //console.log("pass", setting, pair.mac);
              } else {
                if (
                  this.advancedSettings[setting].length == 1 &&
                  (pair.mac == "" || pair.mac == null) &&
                  (pair.name == "" || pair.name == null)
                ) {
                  //console.log("pass single blank row", setting);
                } else {
                  //console.log("invalid", setting, pair.mac);
                  this.error = setting;
                  this.formHasErrors = true;
                  return 0;
                }
              }
            }
          }
        }
      }
      this.formHasErrors = false;
    }
  },
  watch: {
    advancedSettings: function() {
      //console.log("change");
    },
    whiteListMac: function() {
      //console.log("whiteListMac activity");
    }
  }
};
</script>
